import React, { Component, PropTypes } from 'react';

class TwoColumnRow extends Component {

  render() {
    if (this.props.hide) return false;
    const leftColumnStyle = Object.assign({}, {
      float: 'left',
    }, this.props.leftColumnStyle);
    const rightColumnStyle = Object.assign({}, {
      float: 'right',
    }, this.props.rightColumnStyle);
    const outerContainerStyle = Object.assign({}, {
      overflow: 'auto',
      display: 'block',
      marginBottom: '24px',
    }, this.props.outerContainerStyle);
    return (
      <div style={outerContainerStyle}>
        <div style={leftColumnStyle} className={this.props.leftColumnClassName}>
          {this.props.leftColumnContent}
        </div>
        <div style={rightColumnStyle} className={this.props.rightColumnClassName}>
          {this.props.rightColumnContent}
        </div>
      </div>
    );
  }
}

TwoColumnRow.propTypes = {
  leftColumnClassName: PropTypes.string,
  rightColumnClassName: PropTypes.string,
  className: PropTypes.string,
  outerContainerStyle: PropTypes.object,
  leftColumnStyle: PropTypes.object,
  rightColumnStyle: PropTypes.object,
  leftColumnContent: PropTypes.node,
  rightColumnContent: PropTypes.node,
  hide: PropTypes.bool,
};

export default TwoColumnRow;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/two-column-row.jsx